import { InputRange } from 'cwp-components/forms'
import { useSearchParams } from 'react-router-dom'

const RangeFilters = ({ metaData }: any) => {
  const [searchParams, setSearchParams] = useSearchParams()

  const ranges = [
    {
      id: 'price',
      label: 'Price (hourly)',
      paramMin: 'hourly_rate_min',
      paramMax: 'hourly_rate_max',
      min: metaData?.hourly_rate?.min || -1,
      max: metaData?.hourly_rate?.max || 0,
      color: '#9FB7D7',
      formatLabel: (v: number) => v > 0 ? `£${v}` : '?',
      formatTooltip: (v: number) => v > 0 ? (
        <div className='flex items-start gap-0.5'>
          <div className='font-medium text-sm'>£{v}</div>
          <div className='text-[8px] font-bold leading-3 tracking-tight mt-[2px]'>
            p/hr
          </div>
        </div>
      ) : 'n/a',
      className: 'relative w-full',
    },
    {
      id: 'years',
      label: 'Regulated (years)',
      paramMin: 'regulated_years_min',
      paramMax: 'regulated_years_max',
      min: metaData?.regulated_years?.min || -1,
      max: metaData?.regulated_years?.max || 0,
      color: '#205497',
      formatLabel: (v: number) => v > 0 ? `${v} years` : '?',
      formatTooltip: (v: number) => v > 0 ? (
        <div className='flex items-baseline gap-0.5'>
          <div className='font-medium text-sm'>{v}</div>
          <div className='text-[8px] font-bold leading-3 tracking-tight'>
            years
          </div>
        </div>
      ) : 'n/a',
      className: 'relative pt-20 w-full',
    },
  ]
  const handleChange = (
    values: number[],
    paramMin: string,
    paramMax: string,
    min: number,
    max: number,
  ) => {
    const newParams = new URLSearchParams(searchParams.toString())
    values[0] === min
      ? newParams.delete(paramMin)
      : newParams.set(paramMin, values[0].toString())
    values[1] === max
      ? newParams.delete(paramMax)
      : newParams.set(paramMax, values[1].toString())
    setSearchParams(newParams, { replace: true })
  }

  return (
    <div className='flex flex-col space-y-4 w-40 items-center mt-8'>
      {ranges.map(
        ({
          id,
          label,
          paramMin,
          paramMax,
          min,
          max,
          color,
          formatLabel,
          formatTooltip,
          className,
        }) => {
          const currentMin = searchParams.get(paramMin)
          const currentMax = searchParams.get(paramMax)
          const values: number[] = [
            currentMin ? parseInt(currentMin) : min,
            currentMax ? parseInt(currentMax) : max,
          ]

          return (
            <div key={id} className={className}>
              <InputRange
                id={id}
                label={label}
                values={values}
                onChange={(v) => handleChange(v, paramMin, paramMax, min, max)}
                customColor={color}
                min={min}
                max={max}
                step={1}
                disabled={!min || !max || min === -1 || max === 0 || min === max}
                formatMinMaxLabels={formatLabel}
                formatTooltipDisplay={formatTooltip}
              />
            </div>
          )
        },
      )}
    </div>
  )
}

export default RangeFilters
